import FileProviderView from './FileProviderView';
import { observer } from 'mobx-react';
import { AriaProperties, AriaRoles, generateDomPropertiesForAria } from 'owa-accessibility';
import { getIconCSSForFileProvider } from 'owa-fileprovider-icon';
import AttachmentDataProviderScope from 'owa-service/lib/contract/AttachmentDataProviderScope';
import { format } from 'owa-strings';
import strings from 'owa-strings/owa-mail-strings';
import * as React from 'react';
import { FileProviderViewType } from 'owa-fileprovider-store';

export interface FileProviderAndScopesViewProps {
    name: string;
    providerType: FileProviderViewType;
    onClickGenerator: (scope: AttachmentDataProviderScope) => () => void;
    scopes: AttachmentDataProviderScope[];
    isSelected?: boolean;
    selectedScope?: AttachmentDataProviderScope;
}

const classNames = require('classnames');
const styles = require('./FileProviderAndScopesView.scss');

@observer
export default class FileProviderAndScopesView extends React.Component<
    FileProviderAndScopesViewProps,
    {}
> {
    render() {
        const showScopes = this.props.scopes.length > 1;

        return (
            <div>
                {this.createFileProviderView()}

                {showScopes && (
                    <div className={styles.scopesContainer}>
                        {' '}
                        {this.createFileProviderScopeList()}{' '}
                    </div>
                )}
            </div>
        );
    }

    private createFileProviderView() {
        const defaultScope: AttachmentDataProviderScope =
            this.props.scopes.length > 1 ? this.props.scopes[0] : null;
        const scopeToUse: AttachmentDataProviderScope =
            this.props.isSelected && this.props.selectedScope != null
                ? this.props.selectedScope
                : defaultScope;
        const providerIcon = getIconCSSForFileProvider(this.props.providerType);

        return (
            <FileProviderView
                name={this.props.name}
                icon={providerIcon}
                isSelected={this.props.isSelected && this.props.scopes.length < 2}
                ariaLabel={format(strings.FileProviderAriaText, this.props.name)}
                onClick={this.props.onClickGenerator(scopeToUse)}
            />
        );
    }

    private createFileProviderScopeList(): JSX.Element[] | null {
        //We only want to show the scopes if there are at least two to show.
        if (this.props.scopes.length < 2) {
            return null;
        }

        return this.props.scopes.map((scope, index) => {
            const filePickerScopeViewStyles = classNames([
                styles.scope,
                { [styles.scopeSelected]: this.props.selectedScope === scope },
            ]);
            const providerAndScopeName = `${this.props.name}, ${scope.DisplayName}`;
            const ariaProps: AriaProperties = {
                role: AriaRoles.button,
                label: format(strings.FileProviderAriaText, providerAndScopeName),
            };

            return (
                <div
                    key={index}
                    className={filePickerScopeViewStyles}
                    onClick={this.props.onClickGenerator(scope)}
                    data-is-focusable={true}
                    {...generateDomPropertiesForAria(ariaProps)}>
                    {scope.DisplayName}
                </div>
            );
        });
    }
}
